import withResponsive from '../hoc/withResponsive'

export default withResponsive({
  name: 'tabs',

  ui: {
    'tabs[]': '[js-tabs-tab]',
    'contents[]': '[js-tabs-content]',
  },

  events: [
    {
      target: 'tabs',
      on: 'click',
      handle (e) {
        const tab = e.currentTarget
        const contentId = tab.getAttribute('js-tabs-tab')
        const relatedContent = this.ui.contents.filter(el => el.getAttribute('js-tabs-content') === contentId)[0]
        this.ui.tabs.forEach(el => {
          el.classList.remove('is-active')
        })
        tab.classList.add('is-active')
        this.ui.contents.forEach(el => {
          el.classList.remove('is-active')
        })
        relatedContent.classList.add('is-active')
      },
    },
  ],
})
